export const errorMessages = {
  CAMPAIGN_REQUIRED: _TL_('Please select at least one campaign before proceeding to the next step.'),
  CAMPAIGNS_TOO_MANY: _TL_('Your lift experiment can include up to {{max}} campaigns.'),
  CONVERSION_GOAL_REQUIRED: _TL_('Please select a UET tag that has an active conversion goal associated with it.'),
  COUNTRY_REQUIRED: _TL_('Country is required.'),
  KEYWORDS_TOO_LONG: _TL_('You entered {{count}} {{unit}} that {{verb}} the {{max}}-character limit. Please shorten your text.'),
  KEYWORDS_TOO_MANY: _TL_('You entered {{count}} keywords. The lift experiment is limited to {{max}} keywords.'),
  MEASUREMENT_TYPE_REQUIRED: _TL_('You must select at least one lift measurement type.'),
  NAME_REQUIRED: _TL_('Experiment name is required.'),
  NAME_TOO_LONG: _TL_('Experiment name must be 255 or less characters in length.'),
  SAVE_VALIDATION_FAILED: _TL_('You can\'t save this lift experiment. Please fix the errors and try again.'),
  SEARCH_CID_RANGE: _TL_('Customer ID must be between 1 and 999999999.'),
  SEARCH_CID_TYPE: _TL_('Customer ID must be a number.'),
  SELECTED_KEYWORDS_REQUIRED: _TL_('Keywords are required.'),
  START_DATE_REQUIRED: _TL_('Start date is required.'),
  STATUS_INVALID_FOR_EDIT: _TL_('Lift studies can only be edited while they are in a scheduled status.'),
  TYPED_KEYWORDS_REQUIRED: _TL_('Keywords are required.'),
  UET_TAG_SELECTION_REQUIRED: _TL_('Please check below for an issue with your UET tags selection.'),
  UET_REQUIRED: _TL_('UET tags are required.'),
  VISIT_CONVERSION_LIFT_REQUIRED: _TL_('When using \'Visit and conversion lift\', you must choose to measure visit and conversion lift, conversion lift only, or visit lift only.'),
};
